import React , {useState, useEffect,  Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Badge, Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'

import Moment from 'react-moment';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

import CodeView from '../utils/CodeView'
import Meta from '../Meta'
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

export const LLMChat = ({}) => {

    const dispatch = useDispatch()


    const [newModel, setNewModel] = useState("") 

    const [data, setData] = useState([])



    useEffect(() => {
       

    }, [])




    return (

        <>

            <Meta title={'Laeyerz - LLMChat'} description={'Chatting with an LLM using Laeyerz'} keywords={'Laeyerz, AI, LLM, RAG, Agents, QuickStart, Workflows, langchain like'}/>
       
        
                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


                <p className='h3' style={{textAlign:'center'}}>Chatting with an LLM</p>


                <p className='h5'>The simplest example of how to use a Node in Laeyerz.</p>
                <p className='h5'>We create a simple chat app that will take in a user query, send it to OpenAI's GPT model, then return with a response.</p>
                
                </Card>


                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>

                <p className='h5'>Import the Laeyerz Components</p>

                <CodeView text_in={`
from laeyerz.nodes.llm.OpenAILLMNode import OpenAILLMNode as LLM
from laeyerz.utils.KeyManager import KeyManager
                `} />

                </Card>
                


                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>

                <p className='h5'>Load the environment variables using Key Manager</p>

                <CodeView text_in={`key_manager = KeyManager('API KEYS file PATH HERE')
api_key = key_manager.get('OPENAI_API_KEY')`} />

                </Card>


             


                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


                <p className='h5'>Create the LLM Node, use the config dictionary to pass in the API key</p>

                <CodeView text_in={`
llm = LLM("Model", config={"api_key": api_key})
                `}/>

                </Card>



                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


                <p className='h5'>Setup the inputs for the Model.</p>

                <p className='h5'>Select the Model</p>

                <CodeView text_in={`
#select the model
model = "gpt-5-mini"
                `} />

                <p className='h5'>Let us setup the instruction and query to be passed to OpenAI</p>

                <CodeView text_in={`
instructions = "You are a helpful assistant that can summarize the given text"
query = """Artificial intelligence (AI) refers to the ability of computer systems to perform tasks that traditionally require human intelligence. These tasks include learning from experience, reasoning through problems, recognizing patterns, understanding language, perceiving the environment, and making decisions. At its core, AI aims to create machines that can mimic or augment human cognitive abilities in a wide range of situations.

AI is a major field within computer science that develops theories, techniques, and software enabling machines to analyze information, adapt to new inputs, and take actions that help them achieve defined objectives. This involves multiple subfields, such as machine learning—which allows systems to improve performance through data—natural language processing, computer vision, robotics, and expert systems. Together, these technologies enable computers to make sense of complex environments and act intelligently within them.

Modern AI systems work by processing large amounts of data, identifying meaningful patterns, and learning rules or behaviors that help them solve specific problems. They can operate autonomously or as tools that enhance human decision-making. The ultimate goal of AI research is to build systems that are reliable, flexible, and capable of working efficiently in real-world scenarios, thereby increasing productivity, improving user experiences, and supporting better decisions across industries."""

                `} />

<p className='h5'>Now pass the instructions and query in the form of messages to the LLM Node</p>


<CodeView text_in={`
#openai's api takes in messages
messages = [
    {"role": "developer", "content": "Instructions: " + instructions},
    {"role": "user", "content": "User Query: " + query}
    
]

tools = []
                `} />


                </Card>




                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


                <p className='h5'>We are ready to call the LLM Node</p>

                <CodeView text_in={`
 output = llm.call_llm(messages, model, tools )
                `} />



<p className='h5'>We are not passing any tools here. That would be for Agentic use cases.</p>

           

                </Card>



                <Card style={{padding:'20px', marginBottom:'10px', border:'none'}}>


                <p className='h5'>Extract the LLM Output</p>

                <CodeView text_in={`
output_text = output['message'].content
                `} />

                </Card>






                
       
        
        </>

       

   
    )
}


export default LLMChat
